// @ts-nocheck
import { initialState } from './reducer';

const healthCheckSelector = state => state.healthCheck || initialState;

export const getHealthCheckData = state => {
  return healthCheckSelector(state)['healthCheckData'];
};
